import React from 'react'
import walletService from '../Service/walletService'
import { config } from '../Config/config'
import { Modal } from 'react-bootstrap'
import userService from '../Service/userService'

export default class index extends React.Component {
    withdrawModel = {
        customer_id: localStorage.getItem(config.userid),
        wallet_default_nominal_id: "",
        amount: 0,
        bank_name: "",
        account_number: "",
        account_name: localStorage.getItem(config.username),
        otp: "",
        inputPin: ""
    }
    ModelCustom = {
        customer_id: localStorage.getItem(config.userid),
        nominal: ""
    }
    constructor() {
        super()
        this.state = {
            ListDef: [],
            ListCos: [],
            disabled: true,
            display: "none",
            Model: this.withdrawModel,
            showModalNom: false,
            showModalLanjut: false,
            custom_nominal: this.ModelCustom,
            cekNominal: [],
            Wallet: [],
            errors: {},
            showModalAutentikasi: false,
            showModalBerhasil: false
        }
    }

    loadList = async () => {
        var cek = []
        const responWalet = await walletService.getAll(localStorage.getItem(config.userid))
        if (responWalet.result != undefined) {
            this.setState({
                Wallet: responWalet.result,
            })
        }
        const respon = await walletService.getDefault(this.state.Wallet.balance)
        console.log(respon)
        const responcos = await walletService.getCustomNom({ id: localStorage.getItem(config.userid), nominal: this.state.Wallet.balance })
        if (respon.success) {
            for (let i = 0; i < respon.result.length; i++) {
                cek.push(respon.result[i].nominal)
            }
            this.setState({
                ListDef: respon.result
            })
        }
        if (responcos.success) {
            for (let i = 0; i < responcos.result.length; i++) {
                cek.push(responcos.result[i].nominal)
            }
            this.setState({
                cekNominal: cek
            }, () => console.log(this.state.cekNominal))

            if (responcos.result != undefined) {
                this.setState({
                    ListCos: responcos.result
                })
            }
        }
    }

    cancelButton = () => {
        this.setState({
            disabled: true,
            display: "none",
            Model: this.withdrawModel,
            custom_nominal: this.ModelCustom
        })
    }

    componentDidMount() {
        this.loadList()

    }

    buttonNominalHandler = (data) => {
        this.setState({
            Model: {
                ...this.state.Model,
                ["wallet_default_nominal_id"]: data._id,
                ["amount"]: data.nominal
            },
            display: "block",
            custom_nominal: this.ModelCustom
        })
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }

    changeNomHandler = field => ({ target: { value } }) => {
        this.setState({
            custom_nominal: {
                ...this.state.custom_nominal,
                [field]: value
            }
        })
    }



    cancelHandler = () => {
        this.setState({
            showModalNom: false,
            showModalLanjut: false,
            showModalAutentikasi: false,
            errors:{}
        })
    }

    cancelNomHandler = () => {
        this.setState({
            showModalNom: false,
            custom_nominal: this.ModelCustom,
            errors:{}
        })
    }

    cancelBerhasilHandler = () => {
        this.setState({
            showModalBerhasil: false,
            disabled: true,
            display: "none",
            Model: this.withdrawModel,
            custom_nominal: this.ModelCustom
        })
    }
    NominalLainHandler = () => {
        this.setState({
            showModalNom: true,
        })
    }
    // cancelLanjutHandler = () => {
    //     this.setState({
    //         showModalLanjut: false,
    //         showModalAutentikasi:false
    //     })
    // }

    LanjutHandler = () => {
        this.setState({
            showModalLanjut: true
        })
    }

    konfirmasiPin = async () => {
        if (this.handleValidationPin()) {
            this.setState({
                disabled: false,
                showModalLanjut: false,
                showModalAutentikasi: true
            }, () => { walletService.resetWrong(this.state.Wallet) })
        } else if (this.state.Model.inputPin != "") {
            const respon = await walletService.countWrong(this.state.Wallet)
            // console.log(respon)
            if (respon.success) {
                const responWalet = await walletService.getAll(localStorage.getItem(config.userid))
                if (responWalet.success) {
                    this.setState({
                        Wallet: responWalet.result
                    })
                    console.log(responWalet.result.count_wrong)
                    if (responWalet.result.count_wrong == 3) {
                        const responreset = await walletService.resetWrong(this.state.Wallet)
                        if (responreset.success) {
                            const responlock = await userService.lockUser({ _id: localStorage.getItem(config.userid) })
                            if (responlock.success) {
                                localStorage.clear()
                                 window.location="/"
                            }
                        }
                    }
                }

            }
        }
    }

    handleValidationPin() {
        const {Wallet} = this.state
        let fields = this.state.Model
        let errors = {}
        let valid = true
        let kesempatan = 2 - Wallet.count_wrong

        if (this.state.Wallet.pin != this.state.Model.inputPin) {
            valid = false
            errors["pin"] = `pin salah kesempatan anda untuk mencoba tinggal ${kesempatan} `;
        }

        if (!fields['inputPin']) {
            valid = false
            errors["pin"] = "Silakan isi pin terlebih dahulu";
        }

        this.setState({ errors: errors });
        return valid;
    }

    handleValidationNominalLain() {
        let fields = this.state.custom_nominal;
        let errors = {};
        let formIsValid = true;

        if (this.state.cekNominal.includes(parseInt(this.state.custom_nominal.nominal))) {
            formIsValid = false;
            errors["nominal"] = "Nominal sudah ada";
        }
        //Name
        if (parseInt(this.state.custom_nominal.nominal) > this.state.Wallet.balance) {
            formIsValid = false;
            errors["nominal"] = "Nominal penarikan harus lebih kecil dari balance anda";
        }

        if (parseInt(this.state.custom_nominal.nominal) < 0){
            formIsValid = false;
            errors["nominal"] = "Nominal tidak boleh minus"
        }
        
        if (!fields["nominal"]) {
            formIsValid = false;
            errors["nominal"] = "tidak boleh kosong"
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    onKonfirmasiNominal = () => {
        if (this.handleValidationNominalLain()) {
            this.setState({
                Model: {
                    ...this.state.Model,
                    ['wallet_default_nominal_id']: "",
                    ['amount']: parseInt(this.state.custom_nominal.nominal)
                },
                showModalNom: false,
                display: "block",
                errors: {}
            })

        }
    }

    onButtonOk = () => {
        var otp = Math.floor(100000 + Math.random() * 900000)
        otp = otp.toString()
        const { custom_nominal } = this.state
        this.setState({
            Model: {
                ...this.state.Model,
                ['otp']: otp
            }
        }, async () => {
            const responWithdraw = await walletService.withDraw(this.state.Model)
            if (responWithdraw.success) {
                this.setState({
                    showModalBerhasil: true
                })
            }
        })
        if (custom_nominal.nominal != "") {
            walletService.insCustNom({ customer_id: custom_nominal.customer_id, other_balance: custom_nominal.nominal })
        }

    }

    render() {
        const { ListDef, ListCos, disabled, display, Model, showModalNom, showModalLanjut, errors, showModalAutentikasi, showModalBerhasil } = this.state
        return (
            <div class="container">
                <div class="content">
                    <div>
                        {JSON.stringify(this.state.custom_nominal)}
                        <div class="row">

                            <div class="card-box col-6" style={{ height: "500px" }}>
                                <div class="card-body d-flex flex-column" style={{ border: "solid lightBlue", height: "400px" }}>
                                    <label style={{ color: "Blue" }}>Saldo saat ini,Rp.{this.state.Wallet.balance}</label>
                                    <div class="row">
                                        <div class="col-12">
                                            {
                                                ListDef.map(data => {
                                                    return (
                                                        <button type="button" class="btn btn-primary mr-2 mb-2" style={{ height: "35px", width: "75px" }} value={data} onClick={() => this.buttonNominalHandler(data)}>{data.nominal}</button>
                                                    )
                                                })
                                            }
                                            {
                                                ListCos.map(data => {
                                                    return (
                                                        <button type="button" class="btn btn-primary mr-2 mb-2" style={{ height: "35px", width: "75px" }} value={data} onClick={() => this.buttonNominalHandler(data)}>{data.nominal}</button>
                                                    )
                                                })
                                            }
                                            <button type="button" class="btn btn-primary mr-2 mb-2" style={{ height: "35px", width: "75px", fontSize: "8.15px" }} onClick={this.NominalLainHandler}>Nominal Lain</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer align-self-end" style={{ height: "60px", backgroundColor: "#e0f4fc", border: "solid lightBlue" }} ></div>
                            </div>



                            <div class="card-box col-6" style={{ height: "500px" }}>
                                <div class="card-body d-flex flex-column" style={{ border: "solid lightBlue", height: "400px" }}>
                                    <label style={{ color: "Blue", display: `${display}` }}>Anda akan melakukan penarikan saldo sebesar Rp.{Model.amount}</label>
                                    <button type="button" class="btn btn-primary" style={{ display: `${display}` }} onClick={this.LanjutHandler}>lanjut</button>
                                </div>
                                <div class="card-footer align-self-end" style={{ height: "60px", backgroundColor: "#e0f4fc", border: "solid lightBlue" }}>
                                    <div class="text-right">
                                        <button class="btn btn-warning mr-2"  onClick={this.cancelButton}>Cancel</button>
                                        <button class="btn btn-info" disabled={disabled} onClick={this.onButtonOk}>OK</button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <Modal show={showModalNom} onHide={this.cancelNomHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Isi Nominal Lain</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* {JSON.stringify(this.state.Model)} */}
                        {/* {JSON.stringify(this.state.custom_nominal)} */}
                        <div class="main-wrapper account-wrapper">
                            <div class="form-group">
                                <label>Masukan Nominal Lain</label>
                                <input type="Number" class="form-control noArrow" autoFocus onChange={this.changeNomHandler('nominal')} />
                                <span className="error">{errors["nominal"]}</span>
                            </div>
                            <div class="float-justify">
                                <button class="btn btn-outline-primary mr-2" onClick={this.cancelNomHandler}>Cancel</button>
                                <button class="btn btn-info" onClick={this.onKonfirmasiNominal}>OK</button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showModalLanjut} onHide={this.cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Masukan PIN</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* {JSON.stringify(this.state.Model)} */}
                        {/* {JSON.stringify(this.state.custom_nominal)} */}
                        <div class="main-wrapper account-wrapper">
                            <div class="form-group">
                                <label>Masukan Pin</label>
                                <input type="password" maxLength="6" class="form-control" onChange={this.changeHandler('inputPin')} />
                                <span className="error">{errors["pin"]}</span>
                            </div>
                            <div class="float-justify">
                                <button class="btn btn-outline-primary mr-2" onClick={this.cancelHandler}>Cancel</button>
                                <button class="btn btn-info" onClick={this.konfirmasiPin}>OK</button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showModalAutentikasi} onHide={this.cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Autentikasi</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="main-wrapper account-wrapper">
                            <h1>Proses Autentikasi Berhasil</h1>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showModalBerhasil} onHide={this.cancelBerhasilHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>TarikSaldo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="main-wrapper account-wrapper">
                            <h1>Penarikan Saldo Anda Berhasil</h1>
                            <h3>OTP Anda : {Model.otp}</h3>
                            <h5>*OTP akan kadaluarsa dalam 1 jam</h5>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}